import React from 'react'

export const CompleteStepWarning = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="text-black w-full h-[36px] rounded-sm flex items-center justify-center bg-state-attention mb-[40px]">
      <p className="font-[500] leading-[21px] text-[14px]">{children}</p>
    </div>
  )
}
